import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHighmaps from 'react-highcharts/ReactHighmaps.src';
import drilldown from 'highcharts/modules/drilldown';
import { connect } from 'react-redux';
import { map, each, find } from 'lodash';
import { Dropdown, MenuItem } from 'react-bootstrap';
import numeral from 'numeral';

import { format as formatMoney } from '../../../../components/money-display';
import { getColorFromKey } from '../../../../util/helpers';
import ProgressBar from '../../../../components/progress-bar';
import { getGeoStats, getLoaded, getLoading } from '../../AnalysisReducer';
import { fetchMapDataRegion, fetchMapDataMasterRegions } from '../../AnalysisActions';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { getHasNoDecisionSetup } from '../../../../components/search-form/search-form-reducer';
import { getIsFontSizeBig } from '../../../App/AppReducer';

if (typeof window !== 'undefined') {
  drilldown(ReactHighmaps.Highcharts);
}


const MAPTYPES = {
  MASTER_REGION: 1,
  REGION: 2,
  COUNTRY: 3,
};

const USER_PREFERENCE_REPORT_TYPE = 'outcomes-map-report-type';
const USER_PREFERENCE_RATE_TYPE = 'outcomes-map-rate-type';

class MapChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rateType: 'won', // 'won' 'lost', 'noDecision',
      reportType: 'amount', // 'amount', 'count'
      mapData: null,
    };

    this.setRateType = this.setRateType.bind(this);
    this.setReportType = this.setReportType.bind(this);
  }

  componentWillMount() {
    const { userPreferences } = this.context;
    const rateType = userPreferences[USER_PREFERENCE_RATE_TYPE] || 'won';
    const reportType = userPreferences[USER_PREFERENCE_REPORT_TYPE] || 'amount';
    this.setState({ rateType, reportType });
  }

  componentDidMount() {
    this.mounted = true;
    if (!this.state.mapData) {
      this.props.dispatch(fetchMapDataMasterRegions())
        .then((mapData) => {
          if (this.mounted) {
            this.setState({ mapData });
          }
        });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getLabel(input) {
    if (input === 'won') {
      return 'Win';
    } else if (input === 'lost') {
      return 'Loss';
    } else if (input === 'noDecision') {
      return 'No Decision';
    }
    return `${input}`;
  }

  getLabel2(input) {
    if (input === 'won') {
      return 'Won';
    } else if (input === 'lost') {
      return 'Lost';
    } else if (input === 'noDecision') {
      return 'No Decision';
    }
    return `${input}`;
  }

  getLabel3(input) {
    if (input === 'won') {
      return 'Won';
    } else if (input === 'lost') {
      return 'Lost';
    } else if (input === 'noDecision') {
      return 'Pushed';
    }
    return `${input}`;
  }

  setRateType(rateType) {
    this.setState({ rateType });
    this.context.updateUserPreference(USER_PREFERENCE_RATE_TYPE, rateType);
  }
  setReportType(reportType) {
    this.setState({ reportType });
    this.context.updateUserPreference(USER_PREFERENCE_REPORT_TYPE, reportType);
  }

  renderGraph() {
    const { geoStats, organization, isFontSizeBig } = this.props;
    const { reportType, rateType, mapData } = this.state;


    let suffix = '';
    let symbol = '';
    if (organization) {
      suffix = organization.currency_suffix;
      symbol = organization.currency_symbol;
    }

    const data = [];

    const label1 = this.getLabel(rateType);
    const label2 = this.getLabel2(rateType);
    const label3 = this.getLabel3(rateType);
    const rgba = getColorFromKey(rateType, true);


    const formatData = (stat, hcKey, type) => {
      const value = stat[reportType === 'count' ? 'countRate' : 'amountRate'][rateType];
      let statType = MAPTYPES.MASTER_REGION;
      if (type === MAPTYPES.MASTER_REGION) {
        statType = MAPTYPES.REGION;
      } else if (type === MAPTYPES.REGION) {
        statType = MAPTYPES.COUNTRY;
      }
      const datum = {
        'hc-key': hcKey,
        value,
        type: statType,
        color: `rgba(${rgba},${value})`,
        stats: {
          total: reportType === 'count' ? stat.count[rateType] : stat.amount[rateType],
          average: stat.average[rateType],
          count: stat.count[rateType],
          rate: stat[reportType === 'count' ? 'countRate' : 'amountRate'][rateType],
          rateWorld: stat[reportType === 'count' ? 'countRateWorld' : 'amountRateWorld'][rateType],
          activeReps: stat.activeReps,
        },
      };
      if (stat.items) {
        datum.drilldown = hcKey;
        datum.items = map(stat.items, (item, itemK) => formatData(item, itemK, statType));
      }
      return datum;
    };

    const labelFormatter = function labelFormatter() {
      const { stats } = this.point;
      const hasStats = stats !== undefined && stats !== null;
      if (!hasStats) {
        return '';
      }
      const ofTotal = hasStats ? numeral(stats.rateWorld).format('0.0%').toUpperCase() : '';
      return `${this.point.name}${ofTotal ? '<br />' : ''}${ofTotal}`;
    };

    each(geoStats, (stat, k) => {
      data.push(formatData(stat, k, null));
    });

    const self = this;

    const config = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        backgroundColor: 'rgba(0, 0, 0, 0)',
        events: {
          drilldown: function dd(e) {
            if (!e.seriesOptions && e.point.items) {
              const chart = this;
              const { type } = e.point;
              let fetchMapData = null;
              if (type === MAPTYPES.MASTER_REGION) {
                fetchMapData = fetchMapDataMasterRegions(e.point.drilldown);
              } else if (type === MAPTYPES.REGION) {
                fetchMapData = fetchMapDataRegion(e.point.drilldown);
              }
              if (fetchMapData) {
                chart.showLoading('<i class="fa fa-spinner fa-spin"></i>');
                self.props.dispatch(fetchMapData)
                  .then((masterRegion) => {
                    chart.addSeriesAsDrilldown(e.point, {
                      mapData: masterRegion,
                      name: e.point.name,
                      data: e.point.items,
                      dataLabels: {
                        enabled: true,
                        formatter: labelFormatter,
                      },
                    });
                    chart.hideLoading();
                  });
              }
            }
          },
        },
      },
      drilldown: {
        activeDataLabelStyle: {
          color: '#FFFFFF',
          textDecoration: 'none',
          textOutline: '1px #000000',
        },
        drillUpButton: {
          relativeTo: 'spacingBox',
          position: {
            align: 'right',
            verticalAlign: 'top',
          },
        },
      },
      title: {
        text: null,
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      mapNavigation: {
        enabled: false,
      },
      colorAxis: {
        min: 0,

      },
      tooltip: {
        formatter: function f() {
          const { stats } = this.point;
          const total = formatMoney(stats.total, true, 1, symbol, suffix);
          const ofTotal = numeral(stats.rateWorld).format('0.0%').toUpperCase();
          const avg = formatMoney(stats.average, true, 1, symbol, suffix);
          const count = numeral(stats.count).format('0').toUpperCase();
          const activeReps = numeral(stats.activeReps).format('0').toUpperCase();
          const rate = numeral(stats.rate).format('0.0%');
          const color = getColorFromKey(rateType);
          return `<table class="table table-condensed" style="${isFontSizeBig ? 'font-size: 16px;' : ''} margin: 0">
            <thead>
              <tr style="font-size: 1.2em;">
                <th colSpan="2" style="text-align: center;">${this.point.name}</th>
              </tr>
            </thead>
            <tbody>
              <tr style="color: ${color}">
                <td>${label1} Rate</td>
                <td class="text-right">${rate}</td>
              </tr>
              <tr>
                <td>Total ${label2}</td>
                <td class="text-right">${total}</td>
              </tr>
              <tr>
                <td>Deals ${label3}</td>
                <td class="text-right">${count}</td>
              </tr>
              <tr>
                <td>% of Total</td>
                <td class="text-right">${ofTotal}</td>
              </tr>
              <tr>
                <td>Active Reps</td>
                <td class="text-right">${activeReps}</td>
              </tr>
              <tr>
                <td>Average ${label1}</td>
                <td class="text-right">${avg}</td>
              </tr>
            </tbody>
          </table>`;
        },
        useHTML: true,
        backgroundColor: 'rgba(0,0,0, 0.75)',
        borderColor: 'rgba(0,0,0, 0.95)',
        style: {
          color: 'rgba(255, 255, 255, 0.75)',
        },
      },
      plotOptions: {
        map: {
          dataLabels: {
            enabled: true,
            color: 'white',
            style: {
              fontWeight: 'bold',
              fontSize: isFontSizeBig ? '16px' : null,
            },
          },
          mapData,
        },
      },
      series: [{
        data,
        name: 'All Regions',
        states: {
          hover: {
            color: `rgba(${rgba},1)`,
          },
        },
        dataLabels: {
          enabled: true,
          color: '#222222',
          formatter: labelFormatter,
        },
      }],
    };
    return (
      <div>
        <ReactHighmaps config={config} />
      </div>
    );
  }
  render() {
    const { hasNoDecisionSetup } = this.props;
    const { rateType, reportType, mapData } = this.state;
    if (!mapData) {
      return (<div><ProgressBar /></div>);
    }

    const stages = [
      { value: 'won', label: 'Win Rate' },
      { value: 'lost', label: 'Loss Rate' },
    ];
    if (hasNoDecisionSetup) {
      stages.push({ value: 'noDecision', label: 'No Decision Rate' });
    }
    const activeStage = find(stages, { value: rateType }) || { label: 'Rate' };

    const reportTypes = [
      { value: 'amount', label: 'Amount' },
      { value: 'count', label: 'Count' },
    ];
    const activeReportType = find(reportTypes, { value: reportType }) || { label: 'Amount' };

    return (
      <div>
        <div className="animated fadeIn">
          <div>
            <h5 className="sub-header-with-controls">
              View&nbsp;
              <Dropdown
                id="stage-dropdown"
              >
                <Dropdown.Toggle bsSize="small">
                  {activeStage.label}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {stages.map(s => (
                    <MenuItem
                      key={s.value}
                      active={s.value === rateType}
                      onSelect={() => { this.setRateType(s.value); }}
                    >
                      {s.label}
                    </MenuItem>
                    ))}
                </Dropdown.Menu>
              </Dropdown>
              &nbsp;
              <span>for geographic region by</span>
              &nbsp;
              <Dropdown
                id="report-type-dropdown"
              >
                <Dropdown.Toggle bsSize="small">
                  {activeReportType.label}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {reportTypes.map(s => (
                    <MenuItem
                      key={s.value}
                      active={s.value === reportType}
                      onSelect={() => { this.setReportType(s.value); }}
                    >
                      {s.label}
                    </MenuItem>
                    ))}
                </Dropdown.Menu>
              </Dropdown>
            </h5>
            {this.renderGraph()}
          </div>
        </div>
      </div>
    );
  }
}
MapChart.propTypes = {
  dispatch: PropTypes.func.isRequired,
  geoStats: PropTypes.shape({}).isRequired,
  organization: PropTypes.shape({
    organization_id: PropTypes.string.isRequired,
  }).isRequired,
  hasNoDecisionSetup: PropTypes.bool.isRequired,
  isFontSizeBig: PropTypes.bool.isRequired,
  
};
MapChart.contextTypes = {
  updateUserPreference: PropTypes.func.isRequired,
  userPreferences: PropTypes.object.isRequired,
};


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    geoStats: getGeoStats(state),
    loaded: getLoaded(state),
    loading: getLoading(state),
    hasNoDecisionSetup: getHasNoDecisionSetup(state),
    organization: getUserCurrentOrganization(state),
    isFontSizeBig: getIsFontSizeBig(state),
  };
}
export default connect(mapStateToProps)(MapChart);
